/************/

import { Component, OnInit, ViewChild, HostListener, AfterContentInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { Settings } from '../../services/settings';
import { ServiceRequest } from '../../models/service.request';
import { ServiceRequestsService } from '../../services/service-requests.service';
import { ValidationResult } from '../../models/validation-result';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { TransactionHistoryService } from '../../services/transactionhistory.service';
import { TransactionHistoryComponent } from '../../components/transaction-history/transaction-history';
import { DwUtils } from '../../components/utils/dw-utils';
import { RequestStatus } from 'src/app/models/request-status';
import { ServiceRequestType } from 'src/app/models/service-request-type';
import { AgenciesService } from 'src/app/services/agencies.service';
import { ServiceDefService } from 'src/app/services/servicedef.service';
import { ServiceDef } from 'src/app/models/service-def';
import { NotesComponent } from "../../components/notes/notes.component";
import { interval } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { GlobalSearchComponent } from '../requests/globalsearch/globalsearch.component';
import { MembersComponent } from '../common-tabs/members/members.component';
import { CasesService } from 'src/app/services/cases.service';
import { MemberDto } from 'src/app/models/member-dto';
import { AddNewCaseComponent } from "./commands/add-new-case/add-new-case.component";
import { CaseDetailsDialogComponent } from './commands/case-details-dialog/case-details-dialog.component';
import { DuplicateMembersComponent } from '../common-tabs/members/dialogs/duplicate-members/duplicate-members.component';
import { GeneralSetting } from "../../models/generalsetting";
import { HeaderComponent } from "../../components/header/header.component";


export class dataRecord {
	public id: any;
	public description: string;
	constructor(id: any, desc: string) {
		this.id = id;
		this.description = desc;
	}
}

@Component({
	selector: 'app-cases',
	templateUrl: './cases.component.html',
	styleUrls: ['./cases.component.css']
})

export class CasesComponent implements OnInit, AfterContentInit {

	/*** Header / Query Strip Variables ****/
	public formTitle = 'Requests';
	public pagination: string;
	public strFilterText = '';

	/*** Editing variables ***/
	public isEditing: boolean | null = false;
	public isAdd: boolean | null = false;
	public records: MemberDto[];
	public selectedRecord: MemberDto;
	public historyRecord: MemberDto;
	public Idx: number | null = -1;
	public strErr: string | null = '';
	public dataSource: MatTableDataSource<MemberDto>;
	public renderedData: Array<any>;
	public result: boolean | null = false;
	public disabledFlag: boolean | null = true;
	public activeCellId: string | null = '';
	public drawTabIndex: number | null = 0;					/* reset to zero */

	/**** Query strip filter settings ***/
	public selectedStatusFilter: RequestStatus;
	public selectedViewFilter: string | null = 'Open';
	public contentClassWithBanner: string | null = 'dwtable-container-local-cases';
	public contentClassWithoutBanner: string | null = 'dwtable-container-without-header-local-cases';
	public contentClassName: string | null = 'dwtable-container-cases';

	/*** Record Table / card table  ***/
	/*public displayedColumns: string[] = ['id', 'caseNumber', 'caseId', 'applicant', 'caseStatus', 'dateAdded', 'dateClosed', 'btnDetails', 'duplicateStatus', 'memberId', 'fullName', 'relationship',
		'dateOfBirth', 'gender'];*/
	public displayedColumns: string[];

	/*** dialog variables ***/
	public displaySearchDlg = false;
	public displayAddCaseDlg = false;
	public displayCaseDetailsDlg = false;

	public busyCursor: boolean | null = false;
	selectedCaseId = 0;
	public showList: Array<dataRecord>;
	public showStatusList: Array<dataRecord>;
	public saveSortEvent: any | null;
	public requestStatuses: RequestStatus[];
	public serviceRequestTypes: ServiceRequestType[];
	public serviceDefsList: ServiceDef[];

	globalSearchCustomFilter = new dataRecord('Custom', 'Custom');
	autoRefreshInProgress = false;
	isCaseDetailIsEditing = false;

	@ViewChild(MatSort, { static: true }) sort: MatSort;
	@ViewChild('history', { static: true }) history: TransactionHistoryComponent;

	@ViewChild('members', { static: true }) members: MembersComponent;
	@ViewChild('globalSearch', { static: true }) globalSearch: GlobalSearchComponent;
	@ViewChild('addNewCase', { static: true }) addNewCase: AddNewCaseComponent;

	/*** Drawer Children ***/
	@ViewChild('notes', { static: true }) notes: NotesComponent;

	/*** New Service Request Dialog ***/
	@ViewChild('newRequest', { static: true }) newRequest: AddNewCaseComponent;

	/*** Duplicate member Dialog ***/
	@ViewChild('duplicatemember', { static: true }) duplicatemember: DuplicateMembersComponent;
	@ViewChild('header', { static: true }) header: HeaderComponent;

	private alive = true; // Used to control the interval subscription

	public strDuplicatesHeader = 'Duplicate Members';
	public visibleDuplicateDlg = false;
	public bannerEnabled = false;
	visibleAddNewCase = false;
	visibleGlobalSearch = false;
	showRestrictedStatusFilter = false;
	showUnLimitedStatusFilter = false;
	public visibleCaseDOB = false;
	public visibleRelationship = false;
	public visibleCaseId = false;
	public visibleMemberId = false;
	public visibleDedupe = false;
	public allowDedupeAction = false;
	public visibleDOB = false;
	public showCaseDetails = false;

	constructor(public serviceRequestsService: ServiceRequestsService, public casesService: CasesService,
		public dialog: MatDialog, public agenciesService: AgenciesService, private serviceDefService: ServiceDefService) {
		this.selectedRecord = new MemberDto();



		this.visibleDOB = Settings.getInstance().hasPrivilege('CLIENTS_DOB', "SHOW");
		this.visibleRelationship = Settings.getInstance().hasPrivilege('CLIENTS_RELATIONSHIP', "SHOW");
		this.visibleCaseId = Settings.getInstance().hasPrivilege('CLIENTS_CASE_ID', "SHOW");
		this.visibleMemberId = Settings.getInstance().hasPrivilege('CLIENTS_MEMBER_ID', "SHOW");
		this.visibleDedupe = Settings.getInstance().hasPrivilege('CLIENTS_DUPLICATION_FLAG', "SHOW");
		this.allowDedupeAction = Settings.getInstance().hasPrivilege('CLIENTS_DUPLICATION_FLAG', "WRITE");

		const columnFlags = {
			duplicateStatus: this.visibleDedupe,
			memberId: this.visibleMemberId,
			dateOfBirth: this.visibleDOB,
			relationship: this.visibleRelationship,
			caseId: this.visibleCaseId
			// fullName and gender are always shown
		};

		const orderedColumns = [
			'id',
			'caseNumber',
			'caseId',
			'applicant',
			'caseStatus',
			'dateAdded',
			'dateClosed',
			'btnDetails',
			'duplicateStatus',
			'memberId',
			'fullName',
			'relationship',
			'dateOfBirth',
			'gender'
		];

		this.displayedColumns = orderedColumns.filter(col => {
			if (columnFlags.hasOwnProperty(col)) {
				return columnFlags[col];
			}
			return true; // Always include fixed/default columns like fullName and gender
		});
		let genkey: any = Settings.getInstance().getGeneralSettingByKey('bannerenable');
		if (genkey === undefined || genkey === null) {
			genkey = new GeneralSetting();
			genkey.value = 'true';
		}
		this.bannerEnabled = DwUtils.stringToBool(genkey.value);

		this.serviceRequestsService.refreshEvent.subscribe(() => {
			this.refreshButtonClickHandler();
		});

	}

	public ngOnInit() {
		interval(Settings.getInstance().RequestGridAutoRefreshMinutes * 60000)
			.pipe(takeWhile(() => this.alive))
			.subscribe(() => {
				this.refreshData(true);
			});
		if (Settings.getInstance().hasPrivilege('CLIENTS_ADD_NEW', "SHOW")) {
			this.visibleAddNewCase = true;
		} else {
			this.visibleAddNewCase = false;
		}

		this.visibleGlobalSearch = Settings.getInstance().hasPrivilege('CLIENTS_GLOBAL_SEARCH_SHOW', "SHOW");
		this.showRestrictedStatusFilter = Settings.getInstance().hasPrivilege('CLIENTS_SHOW_OPEN_CLOSED', "SHOW");
		this.showUnLimitedStatusFilter = Settings.getInstance().hasPrivilege('CLIENTS_SHOW_ALL', "SHOW");
		this.showCaseDetails = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS', "SHOW");
		if (this.showUnLimitedStatusFilter) {
			this.showList = [
				new dataRecord('Open', 'Open Cases (7 days)'),
				new dataRecord('Closed30', 'Closed (30 days)'),
				new dataRecord('Closed60', 'Closed (60 days)'),
				new dataRecord('All', 'All Cases')];
		} else if (this.showRestrictedStatusFilter) {
			this.showList = [
				new dataRecord('Open', 'Open Cases (7 days)'),
				new dataRecord('Closed30', 'Closed (30 days)'),
				new dataRecord('Closed60', 'Closed (60 days)')];
		} else {
			this.showList = [];
		}
	}
	ngOnDestroy() {
		// Ensure to unsubscribe when the component is destroyed
		this.alive = false;
	}
	public ngAfterContentInit() {
		this.setContentClass();
		this.queryRecords();
	}
	/** set the content class **/
	public setContentClass(): void {

		if (this.bannerEnabled === true) {
			this.contentClassName = this.contentClassWithBanner;
		}
		else {
			this.contentClassName = this.contentClassWithoutBanner;
		}
	}
	/*** Query Records from the Service ***/
	public queryRecords() {

		this.busyCursor = true;

		this.serviceRequestsService.getAllActiveRequestStatuses().subscribe(
			(result) => {
				this.busyCursor = false;
				this.showStatusList = new Array();
				this.requestStatuses = result;
				const deepClone = <T>(obj: T): T => JSON.parse(JSON.stringify(obj));
				Settings.getInstance().requestStatuses = deepClone(result);
				let statusAll: RequestStatus = new RequestStatus();
				statusAll.shortDescription = 'All';
				statusAll.id = 0;
				this.requestStatuses.push(statusAll);
				//this.showStatusList.push(new dataRecord(0, 'All'));
				for (const rec of result) {
					this.showStatusList.push(new dataRecord(rec.id, rec.shortDescription));
				}
				//this.requestStatuses.unshift({ id: 0, shortDescription: 'ALL', recordStatus: '1', description: '' });
				this.selectedStatusFilter = this.getDefaultStatusFilterValue();
				this.busyCursor = true;
				this.serviceRequestsService.getAllServiceRequestTypes().subscribe(
					(result1) => {
						this.serviceRequestTypes = result1;
						Settings.getInstance().serviceRequestTypesList = result1;
						this.busyCursor = false;
						this.serviceDefService.getAllServiceDef().subscribe(
							(result2) => {
								this.serviceDefsList = result2;
								Settings.getInstance().serviceDefsList = result2;
								this.busyCursor = false;
								this.queryCaseData();
							},
							(error2) => {
								Settings.getInstance().handleError('Error: unable to retrieve service defs from' +
									' the' +
									' service');
								this.busyCursor = false;
							}
						);
					},
					(error1) => {
						Settings.getInstance().handleError('Error: unable to retrieve request types from the service');
						this.busyCursor = false;
					}
				);
			},
			(error) => {
				Settings.getInstance().handleError('Error: unable to retrieve service requests from the service');
				this.busyCursor = false;
			}
		);
	}
	public queryCaseData(autoRefreshFlag: boolean = false) {
		let dataObservable;
		this.autoRefreshInProgress = autoRefreshFlag;
		let localSelected = this.selectedRecord;

		this.busyCursor = true;
		if (this.selectedViewFilter === 'Open') {
			dataObservable = this.casesService.getOpenCasesByAgency(Settings.getInstance().loggedInUser.agencyId, 7);
		} else if (this.selectedViewFilter === 'Closed30') {
			dataObservable = this.casesService.getCompletedCasesWithinDays(Settings.getInstance().loggedInUser.agencyId, 30);
		} else if (this.selectedViewFilter === 'Closed60') {
			dataObservable = this.casesService.getCompletedCasesWithinDays(Settings.getInstance().loggedInUser.agencyId, 60);
		}
		else if (this.selectedViewFilter === 'All') {
			dataObservable = this.casesService.getCasesWithinDays(Settings.getInstance().loggedInUser.agencyId, 120);
		}

		if (dataObservable) {
			dataObservable.subscribe(
				(result: MemberDto[]) => {
					this.records = [];
					for (let rec of result) {
						const r = result.find(s => s.caseId === rec.caseId && s['relationship'] === 'Self');
						if (r !== undefined) {
							rec['applicantId'] = r.memberId;
						}
						rec['applicant'] = this.returnFullName(rec, 'a');
						rec['fullName'] = this.returnFullName(rec, 'm');
						this.records.push(rec);
					}

					// this.records = result;
					this.busyCursor = false;
					this.dataSource = new MatTableDataSource(this.records);
					this.dataSource.sort = this.sort;

					if (this.saveSortEvent !== undefined) {
						this.onSortChange(this.saveSortEvent);
					}
					if (this.selectedViewFilter === 'Unmatched') {
						this.selectedStatusFilter = this.getRequestStatusRecordByDesc('Unmatched');
					}
					if (this.selectedViewFilter === 'Completed') {
						this.selectedStatusFilter = this.getRequestStatusRecordByDesc('All');
					}
					this.onChangeStatusFilterValue();
					this.setPagination(-1, this.dataSource.data.length);

					/** if this is an autorefresh, re-select the same
					 * record after the refresh **/
					if (autoRefreshFlag === true) {
						this.applyFilter(this.strFilterText);
						if (localSelected.id > 0) {
							this.selectedRecord = localSelected;
							this.selectRow();
							DwUtils.setFocus('casesTableId');
						}
					}
					else {
						DwUtils.setFocus('txtFilter');
					}
					this.setContentClass();
				},
				(error) => {
					Settings.getInstance().handleError(error, 'Error: unable to retrieve request data from the service');
					this.busyCursor = false;
				}
			);
		}
	}
	/*** Display the number of records from the total ***/
	public setPagination(idx: number, total: number) {
		this.pagination = (idx + 1) + '/' + total;
	}
	public returnFullName(e: any, flag: string): string {
		if (flag === 'm') {
			return DwUtils.returnFullName(e.firstName, e.middleName, e.lastName);
		}
		else {
			return DwUtils.returnFullName(e.applicantFirstName, e.applicantMiddleName, e.applicantLastName);
		}
	}
	public onChangeStatusFilterValue() {
		const dataTemp: MemberDto[] = [];
		if (!this.autoRefreshInProgress === true) {
			this.clearFilter();
		}
		this.clear();
		if (!this.selectedStatusFilter) {
			this.selectedStatusFilter = this.getRequestStatusRecordByDesc('All');
		}
		for (const rec of this.records) {
			//if (rec.caseStatus === this.selectedStatusFilter.id || this.selectedStatusFilter.id === 0) {
			dataTemp.push(rec);
			//}
		}
		this.dataSource = new MatTableDataSource(dataTemp);
		this.setPagination(-1, this.dataSource.filteredData.length);
		this.selectRow();
	}
	public onChangeViewFilterValue() {
		this.showList = this.showList.filter(record => record !== this.globalSearchCustomFilter);
		this.clear();
		if (this.selectedViewFilter === 'My Requests') {
			this.selectedStatusFilter = this.getDefaultStatusFilterValue();
		}
		this.queryCaseData();
	}
	public doTabChange(event): void {
		if (this.selectedRecord) {
		}
	}
	@HostListener('matSortChange', ['$event'])
	public onSortChange(event: any) {
		if (event === undefined) {
			return;
		}

		//if(event.active === 'applicant') {event.active = 'applicantFirstName';}
		//if(event.active === 'fullName') {event.active = 'firstName';}

		this.saveSortEvent = event;

		if (this.dataSource === undefined || this.records === undefined) {
			return;
		}
		try {
			const propComparator = (a: any, b: any) => {
				const propA = this.getPropertyValue(a[event.active]);
				const propB = this.getPropertyValue(b[event.active]);

				if (typeof propA === 'number' && typeof propB === 'number') {
					return event.direction === 'asc' ? propA - propB : propB - propA;
				} else if (propA instanceof Date && propB instanceof Date) {
					return event.direction === 'asc' ? propA.getTime() - propB.getTime() : propB.getTime() - propA.getTime();
				} else {
					const propAStr = propA.toString();
					const propBStr = propB.toString();
					return event.direction === 'asc' ? propAStr.localeCompare(propBStr) : propBStr.localeCompare(propAStr);
				}
			};
			this.dataSource.data = this.dataSource.data.sort(propComparator);
			this.selectRow();
			this.setPagination(this.Idx, this.dataSource.filteredData.length);
		} catch (e) {
			console.log(e);
		}
	}
	public doAddNewCase(): void {
		this.displayAddCaseDlg = true;
		this.addNewCase.onShowHandler();

	}
	public getPropertyValue(value: any): any {
		// Handle special cases for specific data types (e.g., date, number)
		// Add more cases as needed based on the data types
		if (value instanceof Date) {
			return value;
		} else if (!isNaN(value)) {
			return parseFloat(value);
		} else {
			return value ?? '';
		}
	}
	public clearFilter() {
		if (this.dataSource === undefined) {
			return;
		}
		//this.unSelectRow();
		this.dataSource.filter = '';
		this.strFilterText = '';
		this.selectRow();
		this.setPagination(-1, this.dataSource.data.length);
		DwUtils.setFocus('txtFilter');
	}
	public applyFilter(filterValue: string) {

		if (this.dataSource === undefined) {
			return;
		}

		this.dataSource.filter = filterValue.trim().toLowerCase();
		this.unSelectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public selectRow() {
		if (this.selectedRecord.id === 0) {
			this.unSelectRow();
			return;
		}
		this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
		this.reloadSelectedRecord(); // For auto refresh row selection
	}
	public reloadSelectedRecord() {
		if (!this.selectedRecord || this.selectedRecord.id === 0) {
			return;
		}
		for (const rec of this.records) {
			if (this.selectedRecord.id === rec.id) {
				this.selectedRecord = rec;
				return;
			}
		}
	}
	public unSelectRow() {

		if (this.dataSource === undefined) {
			return;
		}

		this.Idx = -1;
		this.setPagination(this.Idx, this.dataSource.data.length);

	}
	public clear(): void {
		this.selectedRecord = new MemberDto();
	}
	public tableKeyDown(event: KeyboardEvent) {
		if (this.isEditing) {
			return;
		}
		const len: number = this.dataSource.filteredData.length;
		if (event.key === 'ArrowDown') {
			if (this.Idx < (len - 1)) {
				this.selectedRecord = this.dataSource.filteredData[++this.Idx];
			}
		} else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.selectedRecord = this.dataSource.filteredData[--this.Idx];
			}
		}
		if (this.dataSource !== undefined) {
			const len: number = this.dataSource.filteredData.length;
			this.setPagination(this.Idx, this.dataSource.filteredData.length);
		}
	}
	public onRowClicked(selected: any) {

		if (this.isEditing === true)
			return;

		this.selectedRecord = selected;
		this.selectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public onRowDoubleClicked(selected: any) {
		if (this.isEditing === true)
			return;
		this.selectedRecord = selected;
		this.doRequestDetails();

	}
	public doRequestDetails(): void {
		if (!this.showCaseDetails) {
			return;
		}
		if (this.selectedRecord) {
			this.displayCaseDetailsDlg = true;
		}
	}

	public lblShowDate(inp: string): string {
		const ret = DwUtils.formatReadableStringNoDay(inp);
		return ret;
	}
	/*** dialogs ***/
	public doGlobalSearch(): void {
		this.displaySearchDlg = true;
		this.globalSearch.onShowHandler();
		this.globalSearch.doInitialize();
	}
	public globalSearchSelect(eventData: any): void {
		this.displaySearchDlg = false;
		this.records = [];
		for (let rec of eventData) {
			const r = eventData.find(s => s.caseId === rec.caseId && s['relationship'] === 'Self');
			if (r !== undefined) {
				rec['applicantId'] = r.memberId;
			}
			rec['applicant'] = this.returnFullName(rec, 'a');
			rec['fullName'] = this.returnFullName(rec, 'm');
			this.records.push(rec);
		}
		//this.records = eventData;

		this.dataSource = new MatTableDataSource(this.records);
		this.showList = this.showList.filter(record => record !== this.globalSearchCustomFilter);
		this.showList.push(this.globalSearchCustomFilter);
		this.selectedViewFilter = 'Custom';
		this.selectedStatusFilter = this.getRequestStatusRecordByDesc('All');
		this.unSelectRow();
		this.setPagination(-1, this.records.length);
	}
	public getDefaultStatusFilterValue() {
		for (const rec of this.requestStatuses) {
			if (rec.shortDescription === 'Matched') {
				return rec;
			}
		}
		return new RequestStatus();
	}
	public doAddCaseSubmitted(event: any): void {
		this.displayAddCaseDlg = false;
		this.queryCaseData();
	}
	public getAgencyName(agencyId: number) {
		return Settings.getInstance().getAgencyName(agencyId);
	}
	public refreshButtonClickHandler() {
		if (this.selectedViewFilter === 'Custom') {
			return;
		}
		this.records = [];
		this.dataSource = new MatTableDataSource(this.records);
		this.queryCaseData();
	}
	public refreshData(autoRefreshFlag: boolean) {
		/** If any of the dialog boxes are open
		 * then suspend the automatic refresh **/
		if (this.displayCaseDetailsDlg === true) {
			return;
		}
		if (this.visibleDuplicateDlg === true) {
			return;
		}
		if (this.displayAddCaseDlg === true) {
			return;
		}
		if (this.displaySearchDlg === true) {
			return;
		}

		if (this.selectedViewFilter === 'Custom') {
			return;
		}

		this.queryCaseData(autoRefreshFlag);
	}
	public getRequestStatusRecordByDesc(param: string) {
		for (const rec of this.requestStatuses) {
			if (rec.shortDescription === param) {
				return rec;
			}
		}
		return undefined;
	}
	public doClose() {
		this.displayCaseDetailsDlg = false;
		this.refreshData(true);

		// this.reloadSelectedRecord();
	}
	public currentDupeRecord: MemberDto = null;
	public openDuplicatesDialog(memberDtoRec: MemberDto) {
		if (this.allowDedupeAction === false) {
			return;
		}
		this.currentDupeRecord = memberDtoRec;
		this.visibleDuplicateDlg = true;
		this.duplicatemember.onShowHandler(memberDtoRec);
	}
	public onDuplicateResolved(event: any) {
		this.visibleDuplicateDlg = false;
		if (this.currentDupeRecord) {
			this.currentDupeRecord.duplicateStatus = event?.resolvedStatus ?? null;
			this.dataSource._updateChangeSubscription();
		}
	}
}
